// src/components/common/LoadingOverlay.jsx
import React from "react";

const LoadingOverlay = ({ message = "Analyzing your resume with AI..." }) => {
  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-60 flex justify-center items-center z-50 transition-opacity duration-300">
      <div className="flex flex-col items-center bg-white rounded-lg p-8 shadow-2xl">
        {/* Professional Spinner */}
        <svg
          className="animate-spin h-12 w-12 text-emerald-600 mb-4"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
        <p className="text-lg font-medium text-gray-700">{message}</p>
        <p className="text-sm text-gray-500 mt-1">
          This may take a moment. Please wait.
        </p>
      </div>
    </div>
  );
};

export default LoadingOverlay;
